import { supabase } from "../lib/supabase";

const BUCKET = "images";

/**
 * Generira jedinstvenu putanju za datoteku (izbjegava prepisivanje).
 * @param {string} folder - npr. "tours/valladolid" ili "travelogues/sevilla"
 * @param {File} file - datoteka
 * @returns {string} putanja u bucketu
 */
function makePath(folder, file) {
  const safeName = (file.name || "image").replace(/[^a-zA-Z0-9._-]/g, "_");
  return `${folder}/${Date.now()}-${safeName}`;
}

/**
 * Upload slike u Supabase Storage (bucket "images").
 * Vraća javni URL slike ili { error }.
 * @param {string} folder - podmapa, npr. "tours/valladolid", "travelogues/sevilla"
 * @param {File} file - datoteka (slika)
 * @returns {Promise<{ url?: string, error?: object }>}
 */
export async function uploadImage(folder, file) {
  if (!file || !file.type?.startsWith("image/")) {
    return { error: { message: "Nije odabrana slika ili format nije podržan." } };
  }
  const path = makePath(folder, file);
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    cacheControl: "3600",
    upsert: false,
  });
  if (error) {
    console.error("Supabase storage upload error:", error);
    return { error };
  }
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return { url: data.publicUrl };
}

/**
 * Briše datoteku iz Storagea (po punom pathu u bucketu).
 * @param {string} path - npr. "tours/valladolid/1234567890-foto.jpg"
 * @returns {Promise<{ error?: object }>}
 */
export async function deleteImage(path) {
  if (!path) return {};
  const { error } = await supabase.storage.from(BUCKET).remove([path]);
  if (error) console.error("Supabase storage delete error:", error);
  return error ? { error } : {};
}

/**
 * Iz URL-a Supabase Storage vraća path u bucketu (za brisanje).
 * Npr. "https://xxx.supabase.co/storage/v1/object/public/images/tours/a.jpg" -> "tours/a.jpg"
 */
export function pathFromPublicUrl(publicUrl) {
  if (!publicUrl || typeof publicUrl !== "string") return null;
  const m = publicUrl.match(/\/storage\/v1\/object\/public\/images\/(.+)$/);
  return m ? m[1] : null;
}
